// extracted by css-extract-rspack-plugin
export default {"dataListToolbar":"NMbiO9Uh_c0gFHD0","dataListToolbarBorder":"pOTFOidE4EMi68Ie"};